<template>
  <v-dialog v-if="!no_data.includes(item)" v-model="dialog" max-width="500px" persistent>
      <v-card class="pa-3">
          <v-card-title>
            <h2 class="title">Resend login info</h2>
          </v-card-title>

          <v-card-text class="mt-5">
              <div>
                <v-layout class="wrap">
                <v-alert
                  outlined
                  color="info"
                  icon="mdi-comment-question"
                >
                  <span class="body-2 default-text">Are you sure you want to resend login info for advertiser {{ item.name }}?</span>
                </v-alert>
                </v-layout>
                <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert" transition="scale-transition">
                    <span class="caption">{{ serverValidationMessage }}</span>
                </v-alert>
            </div>
          </v-card-text>

          <v-card-actions class="px-6">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeResendLoginInfo">Cancel</v-btn>
              <v-btn 
                color="primary"
                :disabled="loading"
                :loading="loading"
                @click="ResendLoginInfo"
              >Send
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>  

<script>
import ApiService from "@/common/api.service";

export default {
  name: 'ResendLoginInfo',
  data: () => ({
    no_data: [null, "", undefined, "null"],
    item: null,
    loading: false,
    dialog: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  mounted () {
    this.$root.$on('ResendLoginInfo', this.openResendLoginInfo)
  },
  beforeDestroy () {
    this.$root.$off('ResendLoginInfo', this.openResendLoginInfo)
  },
  methods: {
    openResendLoginInfo (inputData) {
      this.resetServerValidation()
      this.item = inputData
      this.dialog = true
    },
    ResendLoginInfo () {
      this.resetServerValidation()
      this.loading = true
      ApiService.put(`/admin/organization/${this.item.id}/resend`)
        .then(response => {
          this.$root.$emit("notification", { status: "success", text: `Advertiser ${this.item.name} got a new login info.`});
          this.loading = false
          this.$emit('done')
          this.closeResendLoginInfo()
        })
        .catch(({ response }) => {
          this.loading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(
              response.data.error
            );
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            this.server_errors = response.data.errors;
          }
        });
    },
    closeResendLoginInfo () {
      this.dialog = false
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
  }
}
</script>
